import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cc0002',
    ecrans: ['00-2'],
    params: ['?trmcleint']
});
